'use strict';

/**
 *
 * @name: UserAnalyticsFactory
 *
 */

function UserAnalyticsFactory(
  $analytics
) {

  'ngInject';

  function login(provider) {

    var eventActionLabel = provider;

    if (provider !== 'email') {

      eventActionLabel = 'social networks';
    }

    var properties = {
      eventAction: 'Log in | ' + eventActionLabel,
      eventPoints: 0
    };

    if (provider !== 'email') {

      properties.attributes = {
        label: provider
      };
    } else {

      properties.attributes = {
        label: ''
      };
    }

    return $analytics.eventTrack('Connection', properties);
  }

  function signup(provider) {

    var eventActionLabel = provider;

    if (provider !== 'submit form') {

      eventActionLabel = 'social networks';
    }

    var properties = {
      eventAction: 'Registration | ' + eventActionLabel,
      eventPoints: 0
    };

    if (provider !== 'submit form') {

      properties.attributes = {
        label: provider
      };
    } else {

      properties.attributes = {
        label: ''
      };
    }

    return $analytics.eventTrack('Connection', properties);
  }

  return {
    login: login,
    signup: signup
  };
}

export default UserAnalyticsFactory;



// WEBPACK FOOTER //
// ./app/pages/user/user-analytics.factory.js